import * as React from "react";
const SvgMotor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path fill="#6C737F" d="M16.8 18a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6" />
    <path
      fill="#6C737F"
      d="M19.32 10.8H17.4c-.72-3.24-3.84-5.4-7.08-4.68C7.92 6.6 6 8.4 5.52 10.8h-.84c-1.2 0-2.28 1.08-2.28 2.28v1.56c0 .84.72 1.56 1.56 1.56h.36c0-1.56 1.32-2.88 2.88-2.88 1.56 0 2.88 1.32 2.88 2.88h3.84c0-1.56 1.32-2.88 2.88-2.88 1.56 0 2.88 1.32 2.88 2.88h.36c.84 0 1.56-.72 1.56-1.56V13.2c0-1.32-1.08-2.4-2.28-2.4m-11.88 0c.6-2.28 3-3.48 5.16-2.88 1.32.36 2.4 1.44 2.88 2.88zm-.24 3.6c-.96 0-1.8.84-1.8 1.8 0 .96.84 1.8 1.8 1.8.96 0 1.8-.84 1.8-1.8 0-.96-.84-1.8-1.8-1.8"
    />
  </svg>
);
export default SvgMotor;